import React from "react";
import { Link, useLocation } from "react-router-dom";

const BreadCrumb = () => {
  const location = useLocation();

  // Split the pathname into an array of segments
  const pathnames = location.pathname.split("/").filter((x) => x);

  return (
    // <div className="flex h-full items-center">
    //   <nav aria-label="">
    //     <ul className=" flex gap-2 pl-2 font-semibold">
    //       {pathnames.map((name, index) => {
    //         const routeTo = `${pathnames.slice(0, index + 1).join(">")}`;
    //         const isLast = index === pathnames.length - 1;

    //         return isLast ? (
    //           <li
    //             key={name}
    //             className="breadcrumb-item flex gap-2 active"
    //             aria-current="page"
    //           >
    //             {name.charAt(0).toUpperCase() + name.slice(1)}
    //           </li>
    //         ) : (
    //           <li key={name} className="breadcrumb-item">
    //             <Link to={routeTo}>
    //               {name.charAt(0).toUpperCase() + name.slice(1)}
    //             </Link>
    //           </li>
    //         );
    //       })}
    //     </ul>
    //   </nav>
    // </div>

    <div>
      
    </div>
  );
};

export default BreadCrumb;
